<template>
    <div class="row child-component">
        <div class="col-lg-7 col-md-8 col-sm-8 col-xs-6 mx-auto">
            <div class="d-block row col-lg-8 mx-auto">
                <div class="fieldborder">
                    <label>Employee Phone Number </label>
                    <the-mask type="text" @focus="ResetDirty('EmployeePhoneNumber')"
                        @blur="SetDirty('EmployeePhoneNumber')" :tokens="{ '#': { pattern: /\d/ } }"
                        :mask="['##', FormatPhoneNumber]" style="margin-top:1px;" class="form-control" autocomplete="off"
                        :maxlength="24" v-model="MediaVendor.EmployeePhoneNumber" placeholder="Employee Phone Number"></the-mask>
                </div>
                <div class="fieldborder mt-2">
                    <label>ENTITY </label>
                    <OmniSelect class="" placeholder="Select Entity" name="Entity"
                    :showLabel="false" label="value" v-model="MediaVendor.Entity" :options="EntityList"></OmniSelect>
                </div>
                <div class="fieldborder mt-2">
                    <label>AGENCY </label>
                    <OmniSelect placeholder="Select Agency" name="Media" :showLabel="false" label="Select Media"
                        :options="AgencyList" v-model="MediaVendor.EmployeeAgency" />
                </div>
                <div class="fieldborder pt-2">
                    <OmniSelect v-model="MediaVendor.ClientCode" name="Please select the Client Code that is related to this Media Vendor Request" placeholder="Select Client Code" :allowFiltering="true" :showSearch="true" multiple="true" :options="ClientCodeList" />
                </div>

            </div>
            <!-- <div class="d-block row col-lg-8 offset-lg-2 mt-3 agree-checkbox">
            <b-form-checkbox value="true" v-model="MediaVendor.Attestation">By checking this box, the requestor is confirming that he/she/they has conducted all acceptable measures of due diligence to ensure the propriety of the vendor and confirm that the information contained on the form is accuraate to the best of their knowledge</b-form-checkbox>
        </div> -->
        </div>
        <div class="form-group pt-60 text-right  footer-buttons" style="padding-right:96px !important;">
            <button class="btn btn-link text-uppercase" @click="Cancel()">
                CANCEL
            </button>
            <button v-if="IsDraftVisible" :disabled="!IsFormFilled" class="text-uppercase btn btn-secondary btn-primary" @click="SaveAsDraft()">
                SAVE FOR LATER
            </button>
            <button class="text-uppercase btn custom-button btn-primary" @click="Next()" :disabled="this.$v.$invalid">
                NEXT
            </button>
        </div>

    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { TheMask } from 'vue-the-mask'
import service from "../../../services/Dropdowns";
import { required, minLength } from "vuelidate/lib/validators";
import mediaVendorSaveAsDraft from '../../../mixins/mediaVendorSaveAsDraft';
export default {
  mixins: [mediaVendorSaveAsDraft],
    data() {
        return {
            AgencyList:[],
            EntityList:[],
            ClientCodeList: [],
            EditLoad: {
                EntityLoaded: false,
                AgencyLoaded: false,
            },
            reachUserData:null,
        }
    },
    components: {
        TheMask
    },
    props: {
        id: {
            type: Number,
            required: false,
        },
        isDraft: {
            type: Boolean,
            required: false
        }
    },
    validations: {
        MediaVendor: {
            EmployeePhoneNumber: {
                minLength: minLength(10),
            },
            Entity: {
                required
            },
            EmployeeAgency: {
                required
            },
        }
    },
    async mounted() {
        this.LoadClientCodes();
        this.LoadDropdownValues();
        await this.getReachData();
            if (!(this.CanCreatNewMediaRequest|| this.CanCreateVendorRequest)) {
                this.$router.push({
                    name: "unauthorizedReachData",
                    params: { message: "UnauthorizedReachData" },
                });
            }
    },
    computed: {
        IsAgencyLoaded() {
            return this.EditLoad && this.EditLoad.AgencyLoaded;
        },
        IsEntityLoaded() {
            return this.EditLoad && this.EditLoad.EntityLoaded;
        },
        IsDraftVisible: function () {
            return this.id == null || this.id == 0 || this.isDraft == true;
        },
        IsFormFilled() {
            return this.MediaVendor.Entity !== null || this.MediaVendor.EmployeePhoneNumber !== null || this.MediaVendor.ClientCode !== null;
        },
        IsEdit() {
            return this.id && !isNaN(this.id) && parseInt(this.id) > 0 ? true : false;
        },
        ...mapGetters('mediavendor', {
            MediaVendor: 'MediaVendor',
        }),
        FormatPhoneNumber() {
            const infoFromPhone = this.MediaVendor.EmployeePhoneNumber || '';
            return infoFromPhone.length > 10 ? '####################' : '1-###-###-#####';
        },
        CanCreatNewMediaRequest() {
            return this.reachUserData && this.reachUserData.MailID && this.reachUserData.MailID.trim() != "";
        },
        CanCreateVendorRequest() {
            return this.$store.getters.canCreateVendorRequest;
        },
    },
    activated() {
        this.$parent.$emit("stepInitiated", this.$route.meta.tabIndex);
    },
    methods: {
        async getReachData() {
            try {
                const emailAddress = await this.$store.dispatch("getEmail");
                const res = await this.$store.dispatch("product/GetReachUser", emailAddress);
                this.reachUserData = res.data;
            } catch (ex) {
                if (ex.response) {
                this.$store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                }
            }
        },
        async LoadDropdownValues() {
            service.getOriginalEntityRecords("Financial Entity")
                .then((res) => {
                this.EntityList = res.data;
                    if (this.IsEdit && !this.IsEntityLoaded) {
                        this.LoadEntitySelectedValue();
                    }
                })
                .catch((err) => {
                    alert(err);
                });
        },
        EntityChange() {
            var entityid = this.MediaVendor.Entity;
            service
            .getAgencyDropdownValues(entityid, entityid)
            .then((res) => {
            this.AgencyList = res.data;
            if (this.IsEdit && !this.IsAgencyLoaded) {
                this.LoadAgencySelectedValue();
            } else {
                if (res.data.length == 1) {
                    this.MediaVendor.EmployeeAgency = res.data[0].value;
                } else {
                    this.MediaVendor.EmployeeAgency = null;
                }
            }
            })
            .catch((err) => {
                alert(err);
            });
        },
        async LoadAgencySelectedValue() {
            if (this.IsEdit) {
                this.$set(this.EditLoad, "AgencyLoaded", true);
                await this.AssignAgencyName();
            }
        },
        LoadEntitySelectedValue() {
            if (this.IsEdit) {
                this.$set(this.MediaVendor, "Entity", this.MediaVendor.Entity);
                const entity = this.EntityList.find(item => item.value == this.MediaVendor.Entity);
                this.MediaVendor.EntityName = entity ? entity.label : "";
                this.$set(this.EditLoad, "EntityLoaded", true);
            }
        },
        AssignAgencyName() {
            let agency = this.AgencyList.findIndex((item) => {
                return item.value == this.MediaVendor.EmployeeAgency;
            });
            if (agency > -1) {
                this.MediaVendor.AgencyName = this.AgencyList[agency].label;
            } else {
                this.MediaVendor.AgencyName = "";
            }
        },
        SetDirty(propertyName) {
            this.$v.MediaVendor[propertyName].$touch();

        },
        ResetDirty(propertyName) {
            this.$v.MediaVendor[propertyName].$reset();
        },
        Next() {
            this.$parent.$emit("stepChanged", this.$route.meta.tabIndex);
            if (this.id) {
                this.$router.push({
                    name: "Media Vendor Ledger Media",
                    params: {
                        id: this.id,
                        isDraft: this.isDraft
                    }
                });
            } else {
                this.$router.push({
                    name: "Media Vendor Ledger Media"
                });
            }
        },
        Cancel() {
            this.$router.push("/VendorRequests");
        },
        async LoadClientCodes() {
                this.$store
                    .dispatch("product/GetClients")
                    .then((response) => {
                        this.ClientCodeList = response.data;
                        this.ClientCodeList.forEach(element => { element.value = element.label; });
                    })
                    .catch((ex) => {
                        if (ex.response) {
                        this.$store.dispatch("progress/setErrorMessage", `${ex.response.data}`);
                        } else {
                            this.$store.dispatch(
                                "progress/setErrorMessage",
                                `Error while loading client list.`
                            );
                        }
                    });
        },
        async GetAllMediaTypes() {
            let entity = this.MediaVendor?.EntityName || "";
            if (entity.toLowerCase().includes("zimmerman")) {
                entity = "zimmerman";
            }
            else {
                entity = "Omnicom Media";
            }
            await this.$store
            .dispatch("mediaType/GetMediaTypes", entity)
            .then((res) => {
            if (res.data) {
                // Filter items where ApplicableToFormTypes contains 'Media Vendor'
                const filtered = res.data.filter(item =>
                item.ApplicableToFormTypes && item.ApplicableToFormTypes.split(',').map(type => type.trim()).includes('Media Vendor') 
                );
                const groups = {};
                filtered.forEach(item => {
                    const group = item.MasterMedia?.trim();
                    if (!group) return;
                    if (!groups[group]) {
                        groups[group] = [];
                    }
                    groups[group].push({
                        label: item.MediaTypeName,
                        value: item.MediaTypeName,
                        DisplayOrder: item.DisplayOrder
                    });
                    groups[group].sort((a, b) => a.DisplayOrder - b.DisplayOrder);
                });
                this.MediaVendor.MediaTypesWithDigital = Object.keys(groups).map(groupName => ({
                    label: groupName,
                    value: groups[groupName]
                }));
                if(this.IsEdit) {
                    const selectedMediaTypes = this.MediaVendor.DigitalMediaType || [];
                    const validMediaTypes = filtered.map(item => item.MediaTypeName);
                    const validSelectedMediaTypes = selectedMediaTypes.filter(type => validMediaTypes.includes(type));
                    this.MediaVendor.DigitalMediaType = validSelectedMediaTypes;
                }
                else {                    
                    this.MediaVendor.DigitalMediaType = [];  
                }
            }
            })
            .catch((ex) => {
                if (ex.response) {
                    this.$store.dispatch(
                    "progress/setErrorMessage",
                    `${ex.response.data}`
                    );
                } else {
                    this.$store.dispatch(
                    "progress/setErrorMessage",
                    `Error fetching media types.${ex}`
                    );
                }
            });
        },
    },
    watch: {
        "MediaVendor.Entity": function (val) {
            let entity = this.EntityList.findIndex((item) => {
                return item.value == val;
            });
            if (entity > -1) {
                this.MediaVendor.EntityName = this.EntityList[entity].label;
            } else {
                this.MediaVendor.EntityName = "";
            }
            this.EntityChange(true);
            this.GetAllMediaTypes();
        },
        "MediaVendor.EmployeeAgency": function (val) {
            let agency = this.AgencyList.findIndex((item) => {
                return item.value == val;
            });
            if (agency > -1) {
                this.MediaVendor.AgencyName = this.AgencyList[agency].label;
            } else {
                this.MediaVendor.AgencyName = "";
            }
        },
        "MediaVendor.EmployeePhoneNumber": function() {
            if (this.MediaVendor.EmployeePhoneNumber.length > 10) {
                this.FormatPhoneNumber = true;
            }
            else {
                this.FormatPhoneNumber = false;
            }
        },
    },
}
</script>

<style scoped>
.agree-checkbox .custom-control-label {
    font-weight: 400;
    font-size: 12px;
}
</style>
